{
  "help": "Pomoc",
  "info": "Informacja"
}
